

















































































































































































































import { Component, Vue } from "vue-property-decorator";
import VersionBackModule from "@/store/modules/VersionBack-module";
import { MessageService } from "@/shared/services/message-service";

@Component
export default class VersionControl extends Vue {
  public loading = false;
  public dialog = false;
  public currentVersion = "";
  public currentVersionEnv = "";
  public lastBump = "";

  async mounted() {
    await this.loadCurrentVersion();
  }

  async loadCurrentVersion() {
    try {
      await VersionBackModule.getVersionFront();
      this.currentVersion = VersionBackModule.versionfront;
      await VersionBackModule.getVersionFrontEnv();
      this.currentVersionEnv = VersionBackModule.versionfrontEnv;
    } catch (error) {
      console.error("Error cargando versión:", error);
      MessageService.toast(
        "Error al cargar la versión actual",
        MessageService.TypeError
      );
    }
  }

  confirmBumpVersion() {
    this.dialog = true;
  }

  async bumpVersion() {
    this.loading = true;
    try {
      await VersionBackModule.setVersionFront();

      // Actualizar ambas versiones mostradas (la mutation ya las actualizó en el store)
      this.currentVersion = VersionBackModule.versionfront;
      this.currentVersionEnv = VersionBackModule.versionfrontEnv;
      this.lastBump = new Date().toLocaleString("es-ES");

      this.dialog = false;

      MessageService.toast(
        `✅ Versión incrementada exitosamente a ${this.currentVersionEnv}`,
        MessageService.TypeSuccess
      );

      // Opcional: mostrar un mensaje adicional
      setTimeout(() => {
        MessageService.toast(
          "Todos los clientes se actualizarán automáticamente",
          MessageService.TypeInfo
        );
      }, 1500);
    } catch (error) {
      console.error("Error al incrementar versión:", error);
      MessageService.toast(
        "Error al incrementar la versión",
        MessageService.TypeError
      );
    } finally {
      this.loading = false;
    }
  }
}
